import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW4403Model } from '../kymw4403.model';
import { PublishGoodsGroup } from '../vo/publish-goods-group.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

// レスポンス構造
type GetPublishGoodsGroupSelectItemsResponse = {
  Code: string;
  Name: string;
}[];

/**
 * 掲載商品グループ選択項目取得サービス
 * @export GetPublishGoodsGroupSelectItemsService
 * @class GetPublishGoodsGroupSelectItemsService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetPublishGoodsGroupSelectItemsService extends PlessJsonResponderSub<GetPublishGoodsGroupSelectItemsResponse> {
  model: KYMW4403Model;
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetPublishGoodsGroupSelectItemsService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.model.orderCode,
        MediumType: this.model.mediumType,
      },
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetPublishGoodsGroupSelectItemsService
   */
  execute(model: KYMW4403Model, f: () => void = null): void {
    this.model = model;
    this.calbak = f;
    this.send('getPublishGoodsGroupSelectItems', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetPublishGoodsGroupSelectItemsService
   */
  success(data: GetPublishGoodsGroupSelectItemsResponse) {
    this.model.list = data.map(_ => new PublishGoodsGroup(_.Code, _.Name));
    if (this.calbak) this.calbak();
  }
}
